interface PaginationDotsProps {
    total: number;
    current: number;
    onSelect: (index: number) => void;
}

const PaginationDots = ({
                            total,
                            current,
                            onSelect,
                        }: PaginationDotsProps) => {
    return (
        <div className="flex justify-center gap-2 mt-2 relative z-10 shrink-0">
            {Array.from({ length: total }).map((_, idx) => (
                <span
                    key={idx}
                    onClick={() => onSelect(idx)}
                    className={`w-3 h-3 rounded-full cursor-pointer transition-colors duration-300 ${
                        current === idx
                            ? "bg-blue-600"
                            : "bg-gray-500"
                    }`}
                />
            ))}
        </div>
    );
};

export default PaginationDots;
